import React from 'react';
import { 
  FiFileText, 
  FiRss, 
  FiHelpCircle, 
  FiTrash2, 
  FiRefreshCcw, 
  FiBarChart2 
} from "react-icons/fi";

const BenefitCard = ({ icon: Icon, title, desc }) => (
  <div className="bg-[#F6F6F6] p-4 md:p-6 rounded-[4px] flex items-center gap-4 md:gap-5 transition-all hover:shadow-md border border-transparent hover:border-[#4096F6]/20">
    <div className="w-[45px] h-[45px] md:w-[52px] md:h-[52px] bg-[#4096F6] rounded-full flex items-center justify-center shrink-0 shadow-sm">
      <Icon className="text-white text-[20px] md:text-[24px]" />
    </div>
    <div className="text-left">
      <h4 className="text-[16px] md:text-[18px] font-[500] text-[#000000] font-inter mb-0.5 md:mb-1 tracking-tight leading-tight">
        {title}
      </h4>
      <p className="text-[16px] md:text-[18px] font-[500] text-[#333333B2] font-[500] font-inter leading-snug">
        {desc}
      </p>
    </div>
  </div>
);

const SubscriptionBenefits = () => {
  const benefits = [
    { icon: FiFileText, title: "70,000+ Mock Tests", desc: "Comprehensive test series for all government exams" },
    { icon: FiRss, title: "Unlimited Pro Live Tests", desc: "Live test sessions with expert analysis" },
    { icon: FiHelpCircle, title: "Unlimited Practice Questions", desc: "Practice with unlimited questions & solutions" },
    { icon: FiTrash2, title: "17,000+ Previous Year Papers", desc: "Access to past papers with answer keys" },
    { icon: FiRefreshCcw, title: "Unlimited Re-attempt Mode", desc: "Retake tests to improve your scores" },
    { icon: FiBarChart2, title: "Performance Analytics", desc: "Track progress with detailed insights" }
  ];

  return (
    <div className="bg-white p-5 md:p-10 rounded-[12px] border border-[#E0E0E0] shadow-sm mb-12 md:mb-16 animate-in fade-in duration-700">
      <h2 className="text-center text-[20px] md:text-[24px] font-[500] tracking-tight text-[#000000] mb-8 md:mb-12 font-inter px-2">
        Prime Subscription Plan Benefits
      </h2> 
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 p-1">
        {benefits.map((b, i) => (
          <BenefitCard key={i} {...b} />
        ))}
      </div>
    </div>
  );
};

export default SubscriptionBenefits;